module.exports = __webpack_public_path__ + "static/stork-photo-2-fa22c045d167f527aed1f87b5203ac8d.jpg";